import React, { Component } from 'react';
import * as dateUtil from '../../util/date.util'
export default class BetSlipPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pgLimit: 20,
            pageNo: 1
        };
    }
    componentDidMount() {
    }
    render() {
        let bets = this.props.bets
        let rimBets = bets.length % this.state.pgLimit
        let total_pages = (bets.length - rimBets) / this.state.pgLimit
        if (rimBets > 0) {
            total_pages = total_pages + 1
        }
        let topLimit = this.state.pageNo * this.state.pgLimit
        let bottomLimit = topLimit - this.state.pgLimit
        return (
            <>
                <div id="marketbetspopup" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog" style={{ maxWidth: "300px !important" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myModalLabel">My Bets</h5><button onClick={() => { this.props.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive" style={{ maxHeight: "300px" }}>
                                    <table id="basic-btn" className="table table-bordered font-12 table-sm mb-0">
                                        <tbody>
                                            {this.props.bets.map((bet, i) => {
                                                bet['market_time'] = !!bet.marketName ? dateUtil.getBinaryMarketDisplayName(bet.marketName) : []
                                                return <>
                                                    {i < topLimit && i >= bottomLimit && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                    {this.props.eventTypeId === "300" ? 
                                                        <td>{(!!bet.market_time && bet.market_time.length > 0 ? bet.market_time[0] : bet.marketName)} {!!bet.market_time && bet.market_time.length > 0 && <small className='float-right'><b>[{bet.market_time[1]}]</b></small>}</td>
                                                        :
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        }
                                                        <td className='text-right'>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td className='text-right'>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        {this.props.eventTypeId === "300" && 
                                                            <>
                                                                <td className='text-right wid100'>{bet.liveRate}</td>
                                                                <td className='text-right'><span className={!!bet.pnl && parseFloat(bet.pnl) < 0 ? "text-danger" : "text-success"}><b>{bet.pnl}</b></span></td>
                                                            </>
                                                        }
                                                    </tr>}
                                                </>
                                            })
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                {/* <div className="btn-group d-inline float-right mt-2" role="group" aria-label="Basic example" id="divpagecount">
                                    <div>{bets.length > 0 ? ("From " + (bottomLimit + 1) + " to " + ( (bets.length < topLimit) ? bets.length : topLimit) +" of "+ bets.length+" bets."):null}</div>
                                    <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={() => { if (this.state.pageNo > 1) { this.setState({ pageNo: this.state.pageNo - 1 }) } }} disabled={this.state.pageNo === 1}>Prev</button>
                                    <button className="btn btn-blue" disabled="">{this.state.pageNo}</button>
                                    <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={() => { if (this.state.pageNo < total_pages) { this.setState({ pageNo: this.state.pageNo + 1 }) } }} disabled={this.state.pageNo === total_pages}>Next</button>
                                </div> */}
                            </div>
                            <div className="modal-footer">
                                <div className="row w-100">
                                    <div className="col-12 col-sm-12 col-md-6">
                                        <span className="frleft">{bets.length > 0 ? ("From " + (bottomLimit + 1) + " to " + ((bets.length < topLimit) ? bets.length : topLimit) + " of " + bets.length + " bets.") : null}</span>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                        <div className="btn-group d-inline mr-2 float-right" role="group" aria-label="Basic example" id="divpagecount">
                                            <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={() => { if (this.state.pageNo > 1) { this.setState({ pageNo: this.state.pageNo - 1 }) } }} disabled={this.state.pageNo === 1}>Prev</button>
                                            <button className="btn btn-blue" disabled="">{this.state.pageNo}</button>
                                            <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={() => { if (this.state.pageNo < total_pages) { this.setState({ pageNo: this.state.pageNo + 1 }) } }} disabled={this.state.pageNo === total_pages}>Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="modal-footer">
                                <button type="button" onClick={() => { this.props.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto" data-dismiss="modal">Cancel</button>
                            </div> */}
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
                </div>
            </>
        )
    }
}
